import React from 'react'
import useAutocomplete from '@material-ui/lab/useAutocomplete'
import { AutocompleteInputProps } from './AutocompleteInput.types'
import styles from './AutocompleteInput.module.scss'
import cl from 'classnames'
import { Text1 } from '../Text1'

function AutocompleteInputComponent<OptionType> (props: AutocompleteInputProps<OptionType>) {
  const {
    className,
    style,
    options,
    onOptionSelect,
    getOptionLabel,
    ...rest
  } = props

  const {
    getRootProps,
    getInputProps,
    groupedOptions,
    getListboxProps,
    getOptionProps
  } = useAutocomplete<OptionType>({
    id: 'use-autocomplete',
    options: options,
    getOptionLabel,
    onChange: (_, value) => onOptionSelect(value as OptionType),
    clearOnBlur: true,
    clearOnEscape: true,
    blurOnSelect: true
    // value: {title: 'Fight Club', year: 1999 }
  })

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
      {...getRootProps()}
    >
      <input
        className={styles.input}
        {...rest}
        {...getInputProps()}
      />
      {groupedOptions.length > 0
        ? (
          <ul className={cl(styles.listBox, styles.scrollable)} {...getListboxProps()}>
            {groupedOptions.map((option, index) => (
              <li key={index} {...getOptionProps({ option, index })}>
                <Text1 overflowEllipsis title={getOptionLabel(option)}>
                  {getOptionLabel(option)}
                </Text1>
              </li>
            ))}
          </ul>
        )
        : null}
    </div>
  )
}

const AutocompleteInput = AutocompleteInputComponent
export { AutocompleteInput }
